import React from 'react';
import Section from '../common/Section';
import Pagination from '../common/Pagination';
import SelectInput from '../form/controls/SelectInput';
import PendingProjectRow from './PendingProjectRow';
import { ProjectContext } from '../projects/ProjectContext';
import ProjectService from '../../services/ProjectService';
import StaticData from '../../services/StaticData';
import { PagingSettings } from '../../config/paging';
import TaskService from '../../services/TaskService';

const filterTitle = {
  width: "200px",
  lineHeight: "38px",
  float: "left"
};

const fieldsetStyle = {
  float: "right"
};

const fieldStyle = {
  display: "inline-block",
  float: "left",
  width: "200px"
};

const fieldLabelStyle = {
  display: "inline-block",
  float: "left",
  lineHeight: "38px",
  margin: "0 10px"
};

class PendingProjects extends React.Component {

  constructor(props) {
    super(props);

    this.handleAccept = this.handleAccept.bind(this);
    this.onAssignmentChanged = this.onAssignmentChanged.bind(this);
    this.onPageIndexChanged = this.onPageIndexChanged.bind(this);

    this.state = {
      assignmentStatus: StaticData.AssignmentStatusTypes[0],
      currentPage: 1,
      totalCount: 0,
      projects: []
    };
  }

  componentDidMount() {
    this.loadData();
  }

  handleAccept(projectId, accepted) {

    const data = {
      projectId,
      status: accepted ? 1 : 2
    };

    TaskService
      .updateAssignment(data)
      .then(() => this.loadData());
  }

  loadData() {

    const reqParams = {
      assignmentStatus: this.state.assignmentStatus.id.toString(),
      userId: this.props.user.id,
      page: { number: this.state.currentPage, size: PagingSettings.pageLimit }
    };

    ProjectService
      .getByUserAssignment(reqParams)
      .then(result => this.setState({
        projects: result.items,
        totalCount: result.totalCount
      }));
  }

  onAssignmentChanged(name, value) {
    const newSelection = value ? { ...value } : null;
    this.setState({ assignmentStatus: newSelection }, this.loadData);
  }

  onPageIndexChanged(page) {
    if (this.state.currentPage !== page) {
      this.setState({ currentPage: page }, this.loadData);
    }
  }

  render() {
    return (
      <React.Fragment>
        <Section className="filters">
          <fieldset>
            <div style={filterTitle}>
              <h3>Project assignments</h3>
            </div>
            <div style={fieldsetStyle}>
              <label style={fieldLabelStyle}>Status:</label>
              <div style={fieldStyle}>
                <SelectInput
                  name="assignments"
                  placeholder="Select assignment to filter projects"
                  options={StaticData.AssignmentStatusTypes}
                  multi={false}
                  value={this.state.assignmentStatus}
                  onChange={this.onAssignmentChanged} />
              </div>
            </div>
          </fieldset>
        </Section>
        <Section className="table-content">
          {(this.state.projects &&
            <table>
              {/* <caption>Project assignments</caption> */}
              <thead>
                <tr>
                  <th>DATE</th>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Complexity</th>
                  <th>Company</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ProjectContext.Consumer>
                  {({ returnPath }) => (
                    this.state.projects.map(project =>
                      <PendingProjectRow
                        key={project.id}
                        project={project}
                        returnPath={returnPath}
                        onAccept={this.handleAccept} />)
                  )}
                </ProjectContext.Consumer>
              </tbody>
            </table>)}
        </Section>
        <Pagination
          currentPage={this.state.currentPage}
          pageSize={PagingSettings.pageLimit}
          totalCount={this.state.totalCount}
          visibleRange={PagingSettings.pageRange}
          onPageChanged={this.onPageIndexChanged} />
      </React.Fragment>
    );
  }
}

export default PendingProjects;



// WEBPACK FOOTER //
// ./src/components/home/PendingProjects.js